module.exports = __webpack_public_path__ + "Ubuntu-Medium.8e22c2a6e3a3c679787e.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-Medium.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-Medium.ttf
// module chunks = styles